"use client";

import {
  BackIconSvg,
  BreadcrumbDividerIcon,
} from "@/app/component/Landing/SvgImages";
import { EventLabels } from "@/app/constants/mix-panel-enums";
import AppRoutes from "@/app/constants/routes";
import { useMixPanel } from "@/app/context/mixPanelContext";
import { useAppContext } from "@thriwe-2-0/thriwe-ui-utils";
import parse from "html-react-parser";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";
type Faq = {
  question: string;
  answer: string;
};

// document.title = `Frequently asked questions`;

export default function FAQ() {
  const router = useRouter();

  const {
    state: {},
    instances: { apiRepository },
  } = useAppContext();

  const { trackEvent } = useMixPanel();
  const { t } = useTranslation();
  const [data, setData] = useState<Faq[]>([]);
  const [open, setOpen] = useState("");

  useEffect(() => {
    trackEvent(EventLabels.SL_FAQ, { screen: "Support" });
    apiRepository
      ?.getStaticContent({
        faqs: true,
      })
      .then((v: any) => {
        trackEvent(EventLabels.SL_FAQ_Done, { screen: "Support" });
        setData(v?.data?.faqs ?? []);
      })
      .catch((e: any) => {});
  }, []);

  const toggle = (id: string) => {
    setOpen(open === id ? "" : id);
  };

  const addClassNames = (htmlString: string, isQuestion: boolean) => {
    return parse(htmlString, {
      replace: (domNode) => {
        if (domNode.type === "tag") {
          // Add the class based on the element type (question or answer)
          if (isQuestion) {
            domNode.attribs = {
              ...domNode.attribs,
              class: `${domNode.attribs.class ?? ""} faq-question`.trim(),
            };
          } else {
            domNode.attribs = {
              ...domNode.attribs,
              class: `${domNode.attribs.class ?? ""} faq-answer`.trim(),
            };
          }
        }
        return domNode;
      },
    });
  };

  return (
    <>
      <div className="section_faqs">
        <div className="faqs_container">
          <div className="faqs_heading display_desktop center-text">
            <h1>{t("staticPages.frequentlyAskQuestions")}</h1>
          </div>

          <div className="navigation_container">
            <div className="faqs_navigation_container">
              <div
                className="back_navigation"
                onClick={() => {
                  if (window.history.length > 1) {
                    router.back();
                  } else {
                    window.close();
                  }
                }}
              >
                <span className="back_navigation_icon">
                  <BackIconSvg />
                </span>
                <span className="back_navigation_text">{t("common.back")}</span>
              </div>
            </div>

            <div className="faqs_breadcrumb">
              <div className="breadcrumb_text_container">
                <p
                  className="breadcrumb_text"
                  onClick={() => {
                    router.push(AppRoutes.dashboard);
                  }}
                >
                  {t("common.home")}
                </p>
              </div>
              <div className="breadcrumb_icon_container">
                <span className="d-flex">
                  <BreadcrumbDividerIcon />
                </span>
              </div>
              <div className="breadcrumb_text_container">
                <p className="breadcrumb_text active_breadcrumb">
                  {t("staticPages.frequentlyAskQuestions")}
                </p>
              </div>
            </div>
          </div>

          <div className="faqs_heading display_mobile">
            <h1>{t("staticPages.frequentlyAskQuestions")}</h1>
          </div>

          <div className="faqs_text_container">
            <Accordion
              open={open}
              toggle={toggle}
              style={{ background: "none" }}
            >
              {data.map((item, index) => (
                <AccordionItem
                  key={index}
                  style={{ background: "none !important" }}
                >
                  <AccordionHeader
                    targetId={`${index}`}
                    style={{ background: "none !important" }}
                  >
                    {addClassNames(item.question, true)}
                  </AccordionHeader>
                  <AccordionBody accordionId={`${index}`}>
                    {addClassNames(item.answer, false)}
                  </AccordionBody>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </>
  );
}
